import React from 'react'
import { Button, Input, Checkbox, Row, Col, Icon, Tooltip } from 'antd'
import './styles.css'

const { Search } = Input

function FilterBar({
  searchTerm,
  onSearchChange,
  activeFilterTypes,
  onFilterTypeToggle,
  showUnserviceableOnly,
  onUnserviceableToggle,
  showExpiredOnly,
  onExpiredToggle,
  showClosedPIOnly,
  onClosedPIToggle,
  onReset,
  onDownloadCsv,
  onRefresh,
  loading
}) {
  return (
    <div className="top-bar">
      <div className="top-bar-row">
        {/* Filter by label and checkboxes */}
        <div className="filter-type-selector filter-type-selector-left">
          <span className="filter-by-label">Filter by:</span>
          <Checkbox
            checked={activeFilterTypes.has('presentStatus')}
            onChange={(e) => onFilterTypeToggle('presentStatus', e.target.checked)}
            className="filter-checkbox"
          >
            Present Status
          </Checkbox>
          <Checkbox
            checked={activeFilterTypes.has('location')}
            onChange={(e) => onFilterTypeToggle('location', e.target.checked)}
            className="filter-checkbox"
          >
            Location
          </Checkbox>
          <Checkbox
            checked={activeFilterTypes.has('assetType')}
            onChange={(e) => onFilterTypeToggle('assetType', e.target.checked)}
            className="filter-checkbox"
          >
            Asset Type
          </Checkbox>
          <Checkbox
            checked={activeFilterTypes.has('assetSubType')}
            onChange={(e) => onFilterTypeToggle('assetSubType', e.target.checked)}
            className="filter-checkbox"
          >
            Asset Sub Type
          </Checkbox>
          <Checkbox
            checked={activeFilterTypes.has('subLocation')}
            onChange={(e) => onFilterTypeToggle('subLocation', e.target.checked)}
            className="filter-checkbox"
          >
            Sub Location
          </Checkbox>
          <Checkbox
            checked={activeFilterTypes.has('organisation')}
            onChange={(e) => onFilterTypeToggle('organisation', e.target.checked)}
            className="filter-checkbox"
          >
            Organisation
          </Checkbox>
        </div>

        <div className="filter-type-selector filter-type-selector-right">
          <Search
            placeholder="Search job / asset / location…"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="filter-search"
            style={{ marginBottom: 0 }}
          />

          {/* Reset button */}
          <Button size="small" onClick={onReset} className="filter-button" style={{ marginBottom: 0 }}>
            Reset
          </Button>

          {/* Unserviceable checkbox */}
          <Checkbox
            checked={showUnserviceableOnly}
            onChange={(e) => onUnserviceableToggle(e.target.checked)}
            className="filter-checkbox"
          >
            Unserviceable
          </Checkbox>

          {/* Expired checkbox */}
          <Checkbox
            checked={showExpiredOnly}
            onChange={(e) => onExpiredToggle(e.target.checked)}
            className="filter-checkbox"
          >
            Expired
          </Checkbox>

          {/* ClosedPI checkbox */}
          <Tooltip title="Closed Pending Invoice">
            <Checkbox
              checked={showClosedPIOnly}
              onChange={(e) => onClosedPIToggle(e.target.checked)}
              className="filter-checkbox"
            >
              ClosedPI
            </Checkbox>
          </Tooltip>

          {/* Download button */}
          <Button type="primary" size="small" style={{ marginBottom: 0 }} onClick={onDownloadCsv} className="filter-button">
            <Icon type="download" /> CSV
          </Button>

          {/* Refresh button */}
          <Button
            type="default"
            size="small"
            icon="reload"
            onClick={onRefresh}
            className="filter-button"
            title="Refresh data"
            loading={loading}
            style={{ marginBottom: 0 }}
          />
        </div>
      </div>
    </div>
  )
}

export default FilterBar

